// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_Wv1ec","overlay":"overlay_n4kCp"};